/* Custom Interactive Showcase (sections/custom-interactive-showcase.liquid).
   Vanilla JS, scoped per section instance ([data-pshow]). */
(function () {
  'use strict';

  if (window.CustomInteractiveShowcase) {
    window.CustomInteractiveShowcase.initAll();
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 798px)');
  var fitQuery = window.matchMedia('(min-width: 799px) and (max-width: 1439px)');

  function onMediaChange(mql, handler) {
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
    } else if (mql.addListener) {
      mql.addListener(handler);
    }
  }

  function init(root) {
    if (root.pshowReady) return;
    root.pshowReady = true;

    var card = root.querySelector('[data-pshow-card]');
    if (!card) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pshow-item]'));
    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-pshow-media]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pshow-dot]'));
    var triggers = items.map(function (item) { return item.querySelector('[data-pshow-trigger]'); });
    var progress = root.querySelector('[data-pshow-progress]');
    var pauseBtn = root.querySelector('[data-pshow-pause]');
    var prevBtn = root.querySelector('[data-pshow-prev]');
    var nextBtn = root.querySelector('[data-pshow-next]');
    var status = root.querySelector('[data-pshow-status]');

    var autoplay = root.getAttribute('data-pshow-autoplay') === 'true' && items.length > 1;
    var state = {
      index: 0,
      userPaused: reducedMotion.matches,
      inView: false
    };

    function isRunning() {
      return !state.userPaused && state.inView && !document.hidden;
    }

    function syncVideos() {
      medias.forEach(function (media, i) {
        var video = media.querySelector('video');
        if (!video) return;
        if (i === state.index && isRunning()) {
          video.muted = true;
          video.setAttribute('playsinline', '');
          var played = video.play();
          if (played && played.catch) played.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function syncPlayback() {
      var running = isRunning();
      root.classList.toggle('is-playing', autoplay && running);
      root.classList.toggle('is-paused', state.userPaused);
      if (pauseBtn) {
        pauseBtn.setAttribute(
          'aria-label',
          root.getAttribute(state.userPaused ? 'data-pshow-label-play' : 'data-pshow-label-pause') || ''
        );
      }
      if (status) status.setAttribute('aria-live', autoplay && running ? 'off' : 'polite');
      syncVideos();
    }

    function restartProgress() {
      if (!progress) return;
      progress.classList.remove('is-running');
      void progress.offsetWidth; // restart the CSS animation
      progress.classList.add('is-running');
    }

    function syncTabStops() {
      // On mobile the card is a slider driven by arrows / dots / swipe; the row headings are not controls there.
      triggers.forEach(function (trigger) {
        if (!trigger) return;
        if (mobileQuery.matches) {
          trigger.setAttribute('tabindex', '-1');
        } else {
          trigger.removeAttribute('tabindex');
        }
      });
    }

    function select(index, opts) {
      var count = items.length;
      if (!count) return;
      index = ((index % count) + count) % count;
      state.index = index;

      items.forEach(function (item, i) {
        var active = i === index;
        item.classList.toggle('is-active', active);
        if (triggers[i]) triggers[i].setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      medias.forEach(function (media, i) {
        media.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      if (status && !(opts && opts.silent)) {
        var name = items[index].getAttribute('data-pshow-name') || '';
        status.textContent = name + ' (' + (index + 1) + '/' + count + ')';
      }
      restartProgress();
      syncVideos();
    }

    triggers.forEach(function (trigger, i) {
      if (!trigger) return;
      trigger.addEventListener('click', function () { select(i); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { select(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { select(state.index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { select(state.index + 1); });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        state.userPaused = !state.userPaused;
        syncPlayback();
      });
    }

    if (progress) {
      progress.addEventListener('animationend', function () {
        if (isRunning()) select(state.index + 1, { silent: true });
      });
    }

    // Swipe (mobile slider)
    var touchX = null;
    var touchY = null;
    card.addEventListener('touchstart', function (event) {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    }, { passive: true });
    card.addEventListener('touchend', function (event) {
      if (touchX === null) return;
      var dx = event.changedTouches[0].clientX - touchX;
      var dy = event.changedTouches[0].clientY - touchY;
      touchX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        select(state.index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    // Rotate only while the section is on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        state.inView = entries[entries.length - 1].isIntersecting;
        syncPlayback();
      }, { threshold: 0.35 }).observe(card);
    } else {
      state.inView = true;
    }
    document.addEventListener('visibilitychange', syncPlayback);

    onMediaChange(mobileQuery, syncTabStops);

    // 799–1439px: the right column is narrower than in the 1440 design, so descriptions wrap onto
    // more lines. Give the expanded row the height of the tallest item, so every item fits and the
    // card keeps one height while rotating. (CSS reads --pshow-active-min in that range only.)
    var list = root.querySelector('[data-pshow-list]');
    var fitWidth = -1;
    function fit(force) {
      if (!list) return;
      if (!fitQuery.matches) {
        fitWidth = -1;
        list.style.removeProperty('--pshow-active-min');
        root.classList.remove('is-fitted');
        return;
      }
      var width = list.clientWidth;
      if (!force && width === fitWidth) return;
      fitWidth = width;
      var need = 0;
      items.forEach(function (item) {
        var panel = item.querySelector('.custom__pshow--panel');
        if (!panel) return;
        var pad = parseFloat(window.getComputedStyle(panel).paddingBottom) || 0;
        var bottom = panel.getBoundingClientRect().bottom - pad - item.getBoundingClientRect().top;
        need = Math.max(need, bottom + 24);
      });
      list.style.setProperty('--pshow-active-min', Math.ceil(need) + 'px');
      root.classList.add('is-fitted');
    }
    onMediaChange(fitQuery, function () { fit(true); });
    window.addEventListener('resize', function () { fit(false); });
    window.addEventListener('load', function () { fit(true); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fit(true); });
    }
    onMediaChange(reducedMotion, function () {
      if (reducedMotion.matches) {
        state.userPaused = true;
        syncPlayback();
      }
    });

    // Theme editor: show the selected block and stop rotating
    root.addEventListener('shopify:block:select', function (event) {
      var i = items.indexOf(event.target);
      if (i === -1) return;
      state.userPaused = true;
      select(i);
      syncPlayback();
    });

    syncTabStops();
    fit(true);
    select(0, { silent: true });
    syncPlayback();
    root.classList.add('is-ready');
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-pshow]');
    Array.prototype.forEach.call(roots, init);
  }

  window.CustomInteractiveShowcase = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
